<script lang="ts" module>
  import { Marked, type MarkedExtension } from 'marked';

  import { TeoCore } from '@/teoCore/TeoCore';
  import { executeActionString, isActionString } from '@/teoCore/utility/actionString';
</script>

<script lang="ts">
  let {
    markdown,
    extension,
    class: className,
  }: { markdown: string; extension?: MarkedExtension; class?: string } = $props();
  let md2html = $derived(new Marked(extension ?? {}));
  let html = $derived(markdown ? md2html.parse(markdown) : '');

  function handleAction(e: Event) {
    if (!TeoCore.current) return;
    if (e.target instanceof HTMLAnchorElement) {
      const href = e.target.attributes.getNamedItem('href')?.value;
      if (href && isActionString(href)) {
        e.preventDefault();
        e.stopPropagation();
        executeActionString(TeoCore.current, href);
      }
    }
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleAction(e);
    }
  }
</script>

<div
  class={`teo-markdown-text ${className ?? ''}`}
  onclick={handleAction}
  onkeydown={handleKeyDown}
  role="presentation"
>
  <!--eslint-disable-next-line svelte/no-at-html-tags-->
  {@html html}
</div>
